import Dropdown from '../dropdown/Dropdown'
import Calc from '../calc-input/Calc'
import gsap from 'gsap/gsap-core'
import utilities from "../common/utilities"
import settings from "../common/settings"
import { API } from '@/scripts/common/api/api.services'
import {
    BOOK_A_STAY_URL,
    BOOK_A_STAY_HOTEL_SELECT_URL,
    BOOK_A_STAY_LOGGING_URL
} from '@/scripts/config/api.config'

export class BookingForm {
    constructor(bookingForm, options) {
        this.namespace = bookingForm.dataset.formNamespace || null
        this.$bookingForm = bookingForm
        this.$dateLabel = document.body.querySelector(`#booking__label${this.namespace ? '--' + this.namespace : ''}`)
        this.$roomsLabel = document.body.querySelector(`#rooms__label${this.namespace ?  '--' + this.namespace: ''}`)
        this.$guestsLabel = document.body.querySelector(`#guest__label${this.namespace ? '--' + this.namespace : ''}`)
        this.$ageLabel = document.body.querySelector(`#age__label${this.namespace ? '--' + this.namespace : ''}`)
        this.$destinationInput = this.$bookingForm.querySelector('input[name="destination"]')
        this.$bookingDateInput = document.body.querySelector(`#booking__daterange${this.namespace ? '--' + this.namespace : ''}`)
        this.$roomsInput = document.body.querySelector(`#rooms-form${this.namespace ? '--' + this.namespace : ''}`)

        this.$normalRoomInput = this.$bookingForm.querySelector('.dropdown--rooms')
        this.$suiteInput = this.$bookingForm.querySelector('.dropdown--bedroomsuite')
        this.$villaInput = this.$bookingForm.querySelector('.dropdown--bedroomvilla')

        this.$adultsInput = document.body.querySelector(`#adults-count-form${this.namespace ? '--' + this.namespace : ''}`)
        this.$childrenInput = document.body.querySelector(`#children-count-form${this.namespace ? '--' + this.namespace : ''}`)
        this.$promoInput = this.$bookingForm.querySelector('input[name="promo"]')
        this.$corpIdInput = this.$bookingForm.querySelector('input[name="corpId"]')
        this.$childAgeCol = this.$bookingForm.querySelector('.col--age')
        this.$additionalTriggers = this.$bookingForm.querySelector('.additional-info__trigger')
        this.$additionalCols = this.$bookingForm.querySelectorAll('.additional-col')
        this.$submitButton = this.$bookingForm.querySelector('button[type="submit"]')

        this.APIService = null

        this.formValues = {
            hotelDetail: null,
            bookingDate: {
                startDate: null,
                endDate: null
            },
            rooms: 0,
            guests: {
                adults: 0,
                children: 0,
                childrenAges: []
            },
            promoCode: '',
            corpId: ''
        }

        this.otherAPIData = {}

        this.maxGuestInc = 4
        this.maxGuests = this.maxGuestInc * this.$roomsInput.value

        this.hotelType = 0

        this.dateFormat = settings.dateAPIFormat
        this.animationOptions = Object.assign({
            ease: 'power2.inOut'
        }, options && options.animationOptions)
        this.messageOptions = Object.assign({
            success: 'Success!',
            error: 'Something Went Wrong!'
        }, options && options.messageOptions)
        this.HTTPErrors = null

        this.overlayLoading = false

        this.additionalTl = null
        this.showAdditional = false
        this.events = {}

        this.endDateDefaultInc = this.$bookingForm.dataset.defaultEndDateInc || 2

        this.init()
    }

    init() {

        this.initAPI()
        this.initTweens()
        this.formEvents()
        this.checkForm()
        this.maxGuestUpdater()
        this.addListeners()
        this.genericValueUpdate()
        this.$bookingForm.getForm = () => this
    }

    // setData(msg) {
    //     console.log(msg)
    // }

    initAPI() {
        this.APIService = new API.Controller()
       
    }

    initTweens() {
        const cols = gsap.utils.toArray(this.$additionalCols)
        const triggerIconClose = this.$additionalTriggers.querySelector('.icon-svg--close')
        const triggerIconOpen = this.$additionalTriggers.querySelector('.icon-svg--open')
        const colSpacing = parseInt(utilities.getStyle(cols[0], 'margin-bottom'), 10)
        gsap.set(cols, { autoAlpha: 0, y: -20, marginBottom: 0 })
        gsap.set(triggerIconClose, { display: 'block', scale: 1, autoAlpha: 1 })

        this.additionalTl = gsap.timeline({ paused: true })
            .to(cols, {
                duration: 0.3,
                height: 'auto',
                autoAlpha: 1,
                stagger: 0.05,
                marginBottom: colSpacing,
                y: 0
            })
            .to(triggerIconOpen, {
                scale: 0,
                autoAlpha: 0,
                duration: 0.2,
                display: 'none'
            })
            .from(triggerIconClose, {
                scale: 0,
                autoAlpha: 0,
                duration: 0.2,
                display: 'none'
            })
    }

    openAdditionals() {
        const cols = gsap.utils.toArray(this.$additionalCols)
        this.showAdditional = true
        this.additionalTl.timeScale(1).play()
    }

    closeAdditionals() {
        const cols = gsap.utils.toArray(this.$additionalCols)
        this.showAdditional = false
        this.additionalTl.timeScale(1.5).reverse()
    }

    clearDropdownPanels() {
        const childAgeDropDownPanels = document.body.querySelectorAll('.dropdown__panel--children-age')
        childAgeDropDownPanels.forEach(p => p.remove())
    }

    // Templates
    dropdownTemplate() {
        this.clearDropdownPanels()
        const dropdown = document.createElement('div')
        dropdown.classList.add("dropdown", "dropdown--age")
        dropdown.setAttribute('data-panel-append', 'body')
        dropdown.setAttribute('data-backdrop', 'mobile')
        dropdown.setAttribute('data-panel-mobile', 'bottom')
        dropdown.setAttribute('data-panel-mobile-header', 'Children Ages')

        const dpTpl = `<div class="dropdown__trigger" tabindex="0" data-ripple=""><span class="dropdown__text" id="age__label">Children age *</span><span class="dropdown__icon"> 
            <svg class="icon-svg icon-svg--outline dropdown__icon-svg dropdown__icon-svg--open" ><use xlink:href="#icon-angle-down"></use></svg>
            <svg class="icon-svg icon-svg--outline dropdown__icon-svg dropdown__icon-svg--close" ><use xlink:href="#icon-times"></use></svg></span>
        </div>
        <div class="dropdown__panel dropdown__panel--children-age" aria-hidden="true" ><div class="dropdown__panel-container"></div></div>`

        dropdown.innerHTML = dpTpl
        const dpPanel = dropdown.querySelector('.dropdown__panel')
        const dpPanelContainer = dropdown.querySelector('.dropdown__panel-container')
        const list = document.createElement('div')
        list.classList.add('dropdown__list')

        for (const key in this.formValues.guests.childrenAges) {
            list.appendChild(this.dropdownListItem(parseInt(key) + 1, this.formValues.guests.childrenAges[key]))
        }

        dpPanelContainer.appendChild(list)

        this.$ageLabel = dropdown.querySelector('#age__label')
        new Dropdown(dropdown).init() // Init dropdown
        return dropdown
    }

    dropdownListItem(i, v) {
        const listItem = document.createElement('div')
        listItem.classList.add("dropdown__list-item")
        listItem.innerHTML = `<div class="tile"><span class="tile__text">Child ${i}</span>
                            <span class="tile__action">   
                            </span>
                        </div>`
        listItem.querySelector('.tile__action').appendChild(this.calcItem(i, v))

        return listItem
    }

    calcItem(i, v) {
        const calc = document.createElement('div')
        calc.classList.add("calc")
        calc.id = `child-age-form-${i}`
        calc.dataset.min = 0
        calc.dataset.max = 12
        calc.innerHTML = `<div class="calc__container"><span class="calc__action calc__action--decrement"><svg class="icon-svg icon-svg--outline icon-svg--small"><use xlink:href="#icon-minus"></use></svg></span>
                            <input class="calc__input" type="text" size="" value="${v}"><span class="calc__action calc__action--increment"><svg class="icon-svg icon-svg--outline icon-svg--small"><use xlink:href="#icon-add"></use></svg></span>
                        </div>`
        new Calc(calc) // Init calc
        calc.addEventListener("valueUpdated", (e) => this.childAgeUpdate(i, e))
        return calc
    }

    // remove childage col
    removeChildAgeDropdown() {
        this.$bookingForm.querySelector('.dropdown--age') && this.$bookingForm.querySelector('.dropdown--age').remove()
    }
    // add child age col
    addChildAgeDropdown() {
        this.removeChildAgeDropdown()
        if (this.formValues.guests.children < 1) return
        this.$childAgeCol.appendChild(this.dropdownTemplate())
        this._updateChildAgeHtml()
    }

    // Htmls updates
    _updateDateTitleHtml() {
        let str = ''
        str = (this.formValues.bookingDate.startDate && this.formValues.bookingDate.endDate) ? `${this.formValues.bookingDate.startDate} - ${this.formValues.bookingDate.endDate}` : ''
        this.$dateLabel.innerHTML = str ? str : this.$dateLabel.dataset.placeholder || 'Check in - Check out *'
    }

    _updateRoomsHtml() {
        let str = ''
        const rooms = this.formValues.rooms
        if (rooms) {
            str += rooms > 1 ?  this.$roomsLabel.dataset.placeholder || 'Rooms' :  this.$roomsLabel.dataset.placeholder || 'Room'
            str += `: ${rooms}`
        }

        if (str) {
            this.$roomsLabel.innerHTML = `${str}`
        } else {
            this.$roomsLabel.innerHTML = this.$roomsLabel.dataset.placeholder || `Rooms *`
        }
    }

    _updateGuestHtml() {
        let str = ''
        const adults = this.formValues.guests.adults
        const children = this.formValues.guests.children

        if (adults) {
            str += `${adults}`
            str += adults > 1 ? this.$guestsLabel.dataset.placeholderAdult || ' Adults' : this.$guestsLabel.dataset.placeholderAdult || ' Adult'
        }

        if (children) {
            str += adults ? ', ' : ''
            str += `${children}`
            str += children > 1 ? this.$guestsLabel.dataset.placeholderChildren || ' Childrens' : this.$guestsLabel.dataset.placeholderChildren || ' Children'
        }

        if (str) {
            this.$guestsLabel.innerHTML = `${str}`
        } else {
            this.$guestsLabel.innerHTML = this.$guestsLabel.dataset.placeholder || `Guests *`
        }
    }

    _updateChildAgeHtml() {
        let str = ''
        const agesArray = this.formValues.guests.childrenAges
        agesArray.forEach((v, i) => {
            if (i === 0) str +=  `${this.$ageLabel.dataset.placeholder || 'Children Age'} : `
            str += `${v}`
            if (i !== agesArray.length - 1) str += `, `
        })

        this.$ageLabel.innerHTML = str
    }

    _updateRoomSelect() {
        const $roomSelects = [this.$normalRoomInput, this.$suiteInput, this.$villaInput]
        $roomSelects.forEach(($select) => $select.style.display = 'none')

        switch(parseInt(this.hotelType)) {
            case 0:
                $roomSelects[0].style.display = 'block'
                break 
            case 1:
                $roomSelects[1].style.display = 'block'
                break 
            case 2:
                $roomSelects[2].style.display = 'block'
                break   
        }
    }

    // Checkers and validators
    formError() {

        return this.formValues.hotelDetail === '' ||
            (this.formValues.hotelDetail && this.formValues.hotelDetail.match(/^\s*$/) !== null) ||
            (this.$destinationInput && this.$destinationInput.getAttribute('type')!== 'hidden' && !this.$destinationInput.valid) ||
            this.formValues.bookingDate.startDate === null ||
            this.formValues.bookingDate.endDate === null ||
            !this.formValues.rooms ||
            this.formValues.guests.adults === 0 ||
            this.formValues.guests.adults < this.formValues.rooms ||
            (this.formValues.guests.childrenAges.length && this.formValues.guests.childrenAges.findIndex(c => c === 0) !== -1)
    }

    checkForm() {
        this.addLoader()
        if (!this.formError()) {
            this.$bookingForm.classList.add('booking-form--success')
            this.$submitButton.removeAttribute("disabled")
        } else {
            this.$bookingForm.classList.remove('booking-form--success')
            this.$submitButton.setAttribute("disabled", "")
        }
    }
    // Updates
    // Normal value update
    genericValueUpdate(e) {
        if (this.$roomsInput.value && (this.$roomsInput.value !== this.formValues.rooms)) this.maxGuestSetter()
        if(this.hotelType === 1 && (this.$suiteInput.value !== this.formValues.rooms)) {
            if(parseInt(this.$suiteInput.value) === 1) this.maxGuestInc = 5
            if(parseInt(this.$suiteInput.value) === 2) this.maxGuestInc = 9
            this.maxGuestSetter()
        } 
        if(this.hotelType === 2 && (this.$villaInput.value !== this.formValues.rooms)) {
            if(this.$villaInput.value === 'VLA,VLB') this.maxGuestInc = 7
            if(this.$villaInput.value === 'VLC,VLD') this.maxGuestInc = 9
            this.maxGuestSetter()
        }
        if (this.$destinationInput && this.$destinationInput.dataset.selectedId && this.$destinationInput.dataset.selectedId !== this.formValues.hotelDetail)
            this.onHotelSelect()

        this.formValues = Object.assign(this.formValues, {
            hotelDetail: this.$destinationInput && this.$destinationInput.dataset.selectedId,
            bookingDate: {
                startDate: this.$bookingDateInput.startDate || null,
                endDate: this.$bookingDateInput.endDate && this.$bookingDateInput.endDate !== this.$bookingDateInput.startDate ? this.$bookingDateInput.endDate : null
            },
            //rooms: this.$roomsInput.value,
            promoCode: this.$promoInput.value,
            corpId: this.$corpIdInput.value
        })

        if(this.hotelType === 0) {
            this.formValues.rooms = this.$roomsInput.value
        }

        if(this.hotelType === 1) {
            this.formValues.rooms = this.$suiteInput.value
        }

        if(this.hotelType === 2) {
            this.formValues.rooms = this.$villaInput.value
        }

        this._updateDateTitleHtml()  // Updating title html for Date
        this._updateRoomsHtml() // Updating title html for rooms
        this._updateRoomSelect() // Updating select type
        this.checkForm() // check form
    }
    // Max Guest setters
    maxGuestSetter() {
        const roomCount = this.hotelType === 0 ? this.$roomsInput.value : 1
        this.maxGuests = this.maxGuestInc * roomCount
        this.$childrenInput.setValue(0)

        this.$adultsInput.update({
            min: roomCount
        })
        this.$adultsInput.setValue(roomCount === 1 ? 2 : roomCount)

        this.formValues.guests.childrenAges = []
    }
    // Guest Updater
    maxGuestUpdater() {
        const maxAdults = this.maxGuests - this.$childrenInput.value
        const maxChildren = this.maxGuests - this.$adultsInput.value
        this.$adultsInput.update({
            max: maxAdults
        })

        this.$childrenInput.update({
            max: maxChildren
        })

    }

    // Update for adult calc
    adultsUpdate(e) {
        this.maxGuestUpdater()
        this.formValues.guests.adults = e.detail.value()
        this._updateGuestHtml() // Updating title html for Guest
        this.checkForm() // Check form
    }

    // Update for children calc
    childrenUpdate(e) {
        this.maxGuestUpdater()
        // Pop or push to children age array depending on children number
        if (e.detail.value() !== this.formValues.guests.children) {
            if (e.detail.value() < this.formValues.guests.children) {
                this.formValues.guests.childrenAges.pop()
            } else {
                this.formValues.guests.childrenAges.push(0)
            }
        }

        this.formValues.guests.children = e.detail.value()
        this._updateGuestHtml() // Updating title html for Guest
        this.addChildAgeDropdown() // adding drop down based on number of childrens
        this.checkForm() // Check form
    }

    // Update for children generated age
    childAgeUpdate(i, e) {
        this.formValues.guests.childrenAges[i - 1] = e.detail.value()
        this._updateChildAgeHtml()
        this.checkForm() // Check form
    }

    // Loaders
    addLoader() {
        const loading = this.overlayLoading
        if (!loading) {
            const $loader = this.$bookingForm.querySelector('.overlay-loader')
            if ($loader)
                gsap.to($loader, {
                    autoAlpha: 0,
                    display: 'none',
                    onComplete() {
                        $loader.remove()
                    }
                })
            return
        }
        if (this.$bookingForm.querySelector('.overlay-loader')) this.$bookingForm.querySelector('.overlay-loader').remove()
        this.closeAllDropdowns()
        const $loader = document.createElement('div')
        $loader.classList.add('overlay-loader', 'bg-gray-lighter--faded')
        $loader.innerHTML = `<span class="overlay-loader__spinner spinner-border"></span>`
        gsap.from($loader, {
            autoAlpha: 0
        })

        if ($loader) this.$bookingForm.appendChild($loader)
    }

    // On Hotel Select
    async onHotelSelect() {
        
        if (this.overlayLoading) return
        this.otherAPIData = {}
        this.overlayLoading = true
        const data = await this.APIService.getFetch(`${BOOK_A_STAY_HOTEL_SELECT_URL}?hotelId=${this.$destinationInput.dataset.selectedId}&langId=${settings.locale}`)
        Object.assign(this.otherAPIData, {
            ...data.hotel
        })
        if (data.settings.maxoccupancy) {
            this.maxGuestInc = data.settings.maxoccupancy
            this.$roomsInput.setValue(1) // To Update room value set to 1
        } else {
            this.maxGuestInc = 4
        }
        this.$bookingDateInput.updateDateOptions({
            maxSpan: {
                "days": data.settings.maxnights || 120
            }
        })
        if(data.settings.startingdate)
            this.$bookingDateInput._setMinDate(data.settings.startingdate)
            ._setStartDate(data.settings.startingdate)
            ._setEndDate( data.settings.endingdate || new Date (new Date(data.settings.startingdate).setDate(new Date(data.settings.startingdate).getDate() + parseInt(this.endDateDefaultInc))) )
        
        this.hotelType = data.settings.hotelType || 0
        this.$roomsInput.setValue(1) // To reset rooms value
        this.$suiteInput.setValue(1) // To Reset Suite value
        this.$villaInput.setValue('VLA,VLB') // To Reset Villa value
        this.overlayLoading = false
        this._updateRoomSelect() // For select for different type of hotels
        this.checkForm()
       
    }

    trackerLink() {
        if (typeof(window["ga"]) !== "undefined") {
            var firstTracker = ga.getAll()[0]
            if (firstTracker) return firstTracker.get("linkerParam")
        }

        return false
    }

    // On form Submit
    async onsubmit(e) {
        e.preventDefault()
        this.HTTPErrors = null
        // Rooms string =&gt; Rooms dropdown selected value
        // dest string =&gt; if it returns as Get SynxisPost Data api response
        // hotellist string =&gt; if it returns as Get SynxisPost Data api response
        // Hotel string =&gt; if it returns as Get SynxisPost Data api response
        // start string =&gt; if it returns as Get SynxisPost Data api response
        // arrive string =&gt; Datepicker value
        // adult string =&gt; Adults dropdown selected value
        // child string =&gt; Children dropdown selected value
        // nights string =&gt; Nights dropdown selected value
        // childages string =&gt; Child Ages dropdown selected value (by separated by comma)
        // locale string =&gt; if it returns as Get SynxisPost Data api response
        // Rate string =&gt; Promotion Code textbox value
        // room string =&gt; if it returns as Get SynxisPost Data api response
        // IATA string =&gt; IATA textbox value
        // template string =&gt; if it returns as Get SynxisPost Data api response
        // session string =&gt; if it returns as Get SynxisPost Data api response

        if (!this.formError()) {
            this.$submitButton.classList.add('btn-loading')
            const SubmitData = {
                Hotel: this.formValues.Hotel,
                arrive: `${utilities.formatDateForApi(this.formValues.bookingDate.startDate)}`,
                nights: utilities.noOfDays(this.formValues.bookingDate.startDate, this.formValues.bookingDate.endDate),
                Rooms: this.formValues.rooms,
                adult: this.formValues.guests['adults'],
                child: this.formValues.guests['children'],
                childages: `${this.formValues.guests.childrenAges.map((age, i) => age)}`, // same as Array.join(',')
                Rate: this.formValues.promoCode,
                IATA: this.formValues.corpId,
                ...this.otherAPIData
            }

            const form = document.createElement("form")

            Object.assign(form.style, {
                overflow: 'hidden',
                height: 0,
                opacity: 0
            })
            
            const actionLink = !this.trackerLink() ? BOOK_A_STAY_URL : `${BOOK_A_STAY_URL}&${this.trackerLink()}`
            form.method = "POST"
            form.action = actionLink

            if(BOOK_A_STAY_LOGGING_URL) {
                this.APIService.post(BOOK_A_STAY_LOGGING_URL, {
                    "book_url": actionLink,
                    "form_data": SubmitData
                })
            }

            for (const [key, value] of Object.entries(SubmitData)) {
                const input = document.createElement("input")
                input.value = value
                input.name = key
                form.appendChild(input)
            }
            document.body.appendChild(form);
            form.submit()
            return
        }

        this.$bookingForm.dispatchEvent(this.events['error'])
    }

    // Utils
    // Close Dropdowns
    closeAllDropdowns() {
        const $dds = this.$bookingForm.querySelectorAll('.dropdown')
        $dds.forEach($dd => $dd.panelClose())
    }

    // Events
    formEvents(type) {
        this.events['success'] = new CustomEvent('formSuccess', {
            bubbles: false,
            detail: {
                getValues: () => this.formValues
            }
        })

        this.events['error'] = new CustomEvent('formError', {
            bubbles: false,
            detail: {
                error: () => 'Form has errors!'
            }
        })
    }

    // Event Listeners
    addListeners() {
        this.$adultsInput.addEventListener("valueUpdated", (e) => this.adultsUpdate(e))
        this.$childrenInput.addEventListener("valueUpdated", (e) => this.childrenUpdate(e))

        this.$bookingDateInput.addEventListener('dateUpdated', (e) => this.genericValueUpdate())
        if (this.$destinationInput) this.$destinationInput.addEventListener("change", () => this.genericValueUpdate())
        this.$roomsInput.addEventListener("valueUpdated", () => this.genericValueUpdate())
        this.$suiteInput.addEventListener("select", () => this.genericValueUpdate())
        this.$villaInput.addEventListener("select", () => this.genericValueUpdate())
        this.$promoInput.addEventListener("change", () => this.genericValueUpdate())
        this.$corpIdInput.addEventListener("change", () => this.genericValueUpdate())

        this.$additionalTriggers.addEventListener("click", (e) => {
            e.preventDefault()
            !this.showAdditional ? this.openAdditionals() : this.closeAdditionals()
        })

        this.$bookingForm.addEventListener("submit", (e) => this.onsubmit(e))
    }

}